module.exports = __webpack_public_path__ + "static/media/Lohana-Samaj-Bureau.4d37d6cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/Lohana-Samaj-Bureau.jpg
// module id = 1011
// module chunks = 0